import { useEffect, useState } from "react";
import "../../Event.scss";
import type { RechargeOfferProps } from "./RechargeOffer.types";
import { useCountdownTo } from "../../../../hooks/useUtils";
import { useNavigation, ROUTES } from "../../../../utils/navigation";
import RechargeOfferImg from "@/assets/homePage/RechargeOfferImg.webp";
import { RechargePromoDialog } from "../RechargePromoDialog/RechargePromoDialog";
import { useT } from "@/i18n/hooks";

// 计算“目标市场当晚24:00”的绝对时间戳（毫秒）。
const checkEndAt = (): number => {
  const now = new Date();
  // 使用本地时区：构造下一天 00:00:00.000 的时间
  const nextMidnight = new Date(now);
  nextMidnight.setHours(24, 0, 0, 0); // 今日的 24:00 即明日 00:00
  return nextMidnight.getTime();
};

export const RechargeOffer: React.FC<RechargeOfferProps> = ({
  className = "",
  visible,
  onClose,
  taskData,
}) => {
  const t = useT();
  const { navigate } = useNavigation();
  // 倒计时目标：当天 24:00（明日 00:00）
  const [endAt, setEndAt] = useState<number>(() => checkEndAt());
  const { hms, isFinished, start } = useCountdownTo(endAt);

  // 启动倒计时
  useEffect(() => {
    start();
  }, [start, endAt]);

  useEffect(() => {
    if (isFinished) {
      const next = checkEndAt();
      setEndAt(next);
      start();
    }
  }, [isFinished, start]);

  const amount = taskData?.rewardAmount ?? 0;

  // 无可用优惠时不显示
  if (amount === 0) return null;

  return (
    <RechargePromoDialog
      className={className}
      visible={visible}
      onClose={onClose}
      hms={hms}
      amount={amount}
      img={RechargeOfferImg}
      description={t("event.rechargeOffer.description")}
      buttonText={t("common.deposit")}
      buttonOnClick={() => {
        onClose();
        sessionStorage.setItem("autoSelectBestOffer", "true");
        navigate(ROUTES.RECHARGE);
      }}
    />
  );
};

export default RechargeOffer;
